import {
  Box,
  Button,
  Flex,
  Table,
  TableTbody,
  TableTd,
  TableTh,
  TableThead,
  TableTr,
  Title,
} from '@mantine/core';
import { WithRecords } from '../wrappers/WithRecords';
import { UserFilter, UserFilters } from '../components/UserFilters';
import { User, page, remove, update } from '../api/users';
import { IconPencil, IconPlus, IconTrash } from '@tabler/icons-react';
import { useState } from 'react';
import { Date } from '../components/Date';

export const Users = () => {
  const [filters, setFilters] = useState<UserFilters>({});
  return (
    <Box>
      <Flex mr={12} justify="space-between">
        <Title order={3} mb={12}>
          Users
        </Title>
        <Button
          component="a"
          href={`/users/create`}
          color="blue"
          leftSection={<IconPlus />}
        >
          Create User
        </Button>
      </Flex>
      <UserFilter onChange={(k, v) => setFilters({ ...filters, [k]: v })} />
      <WithRecords
        getPage={page}
        remove={remove}
        restore={(token, id) => update(token, id, { deletedAt: null })}
        showDeleted={false}
        filters={filters}
      >
        {(results, removeItem, restoreItem) => (
          <Table.ScrollContainer minWidth={500} mb="lg">
            <Table>
              <TableThead>
                <TableTr>
                  <TableTh>ID</TableTh>
                  <TableTh>Username</TableTh>
                  <TableTh>Roles</TableTh>
                  <TableTh>Created At</TableTh>
                  <TableTh>Updated At</TableTh>
                  <TableTh></TableTh>
                </TableTr>
              </TableThead>
              <TableTbody>
                {results.map((result: User) => (
                  <TableTr key={result._id}>
                    <TableTd>{result._id}</TableTd>
                    <TableTd>{result.username}</TableTd>
                    <TableTd>{result.roles.join(', ')}</TableTd>
                    <TableTd>
                      <Date isoString={result.updatedAt} />
                    </TableTd>
                    <TableTd>
                      <Date isoString={result.createdAt} />
                    </TableTd>
                    <TableTd>
                      <Flex gap={12} justify="flex-end">
                        <Button
                          color="blue"
                          component="a"
                          leftSection={<IconPencil />}
                          href={`/users/${result._id}`}
                        >
                          Edit
                        </Button>
                        {result.deletedAt ? (
                          <Button
                            color="green"
                            onClick={() => restoreItem(result._id)}
                          >
                            Restore
                          </Button>
                        ) : (
                          <Button
                            leftSection={<IconTrash />}
                            color="red"
                            onClick={() => removeItem(result._id)}
                          >
                            Remove
                          </Button>
                        )}
                      </Flex>
                    </TableTd>
                  </TableTr>
                ))}
              </TableTbody>
            </Table>
          </Table.ScrollContainer>
        )}
      </WithRecords>
    </Box>
  );
};
